import styled from 'styled-components'
import { Type } from 'theme/types'

export const TitleWhatsappLogin = styled.h1`
  ${({theme}: Type) => theme?.login?.text?.title}
`

export const TextWhatsappLogin = styled.p`
  ${({theme}: Type) => theme?.login?.text?.textRecovery}
`
